import { Router } from '@angular/router';

export class AppHelper {
  public static isRouteActive(commands: any[] = [], router: Router): boolean {
    return router.isActive(router.createUrlTree(commands), {
      paths: 'exact',
      queryParams: 'exact',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }
}

export function postMessageToWebview(windowRef: Window | null, message: any): void {
  if (windowRef?.ReactNativeWebView) {
    windowRef.ReactNativeWebView.postMessage(JSON.stringify(message));
  }
}

/**
 * @param url
 * @param expiryOffsetSec unit: second.
 */
export function isExpiredS3URL(url: string, expiryOffsetSec: number = 0): boolean {
  const searchParams = new URLSearchParams(url);
  const dateStr = searchParams.get('X-Amz-Date');
  const expiresStr = searchParams.get('X-Amz-Expires');
  if (!dateStr || !expiresStr) {
    throw new Error('ERROR at isExpiredS3URL'); // NOSONAR
  }
  const date = new Date(dateStr.replace(/(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z/, '$1-$2-$3T$4:$5:$6Z'));
  const expires = Number(expiresStr);
  const t1 = (Date.now() - date.getTime()) / 1000;
  const t2 = expires - expiryOffsetSec;
  console.debug(`Debug isExpiredS3URL: ${JSON.stringify({ t1, t2, date, expires, expiryOffsetSec, result: t1 > t2 })}`); // NOSONAR
  return t1 > t2;
}
